import axios, { CancelToken } from 'axios';

// TODO: return extensible instances or composable fns for each consumer (service)

class ApiService {
  constructor(requestProvider) {
    this.requestProvider = requestProvider;
  }

  get(route, params, cancelToken) {
    return this.requestProvider.get(route, { params, cancelToken });
  }

  // TODO: remove this one
  getWithCallbacks(route, params, successCallback, errorCallback) {
    return this.get(route, params)
      .then(successCallback)
      .catch(errorCallback);
  }

  post(route, data) {
    return this.requestProvider.post(route, data);
  }

  // TODO: remove this one
  postWithCallbacks(route, data, successCallback, errorCallback) {
    return this.requestProvider
      .post(route, data)
      .then(successCallback)
      .catch(errorCallback);
  }

  // TODO: remove callbacks
  put(route, data, successCallback, errorCallback) {
    return this.requestProvider
      .put(route, data)
      .then(successCallback)
      .catch(errorCallback);
  }

  delete(route, params) {
    return this.requestProvider.delete(route, { params });
  }
}

export function getCancelable() {
  return CancelToken.source();
}

export default new ApiService(axios);
